/* eslint-disable no-console */
import React, { useContext, useEffect, useState, useMemo } from 'react';
// import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';

import getI18nService from '../../i18n/i18n';
import { Context } from '../../store/Store';
import { getStorageItem } from '../../common/Storage';
import { callFetchData } from '../../common/Fetch';
import userService from '../../api/UserService';
import Logo from '../includes/Logo';
import Footer from '../includes/Footer';

const i18n = getI18nService();

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const PassThroughAccessSuccess = () => {
  const [state, dispatch] = useContext(Context);
  const { ui } = state;
  const { customization } = ui || {};
  const [tenantName, setTenantName] = useState('-');
  const [postLoginContent, setPostLoginContent] = useState(null);
  const [parsedContent, setParsedContent] = useState(null);
  const { api, emailData } = state;
  const portalData = api['get_portal'];
  const query = useQuery();
  const forward = query.get('forward');
  const sessionId = getStorageItem('sessionId');

  useEffect(() => {
    let tName = getStorageItem('tenantName');
    const displayName = getStorageItem('displayName');
    if (portalData) {
      tName = portalData.tenantName;
    }
    if (displayName !== '') {
      tName = displayName;
    }
    let eData = getStorageItem(userService.UserLogin.name);
    if (emailData) {
      eData = emailData;
    }
    setTenantName(tName);
  }, []);

  useEffect(() => {
    const getPostLoginContent = async () => {
      const api = Object.assign({}, userService.GetPostLoginContent, {
        data: { sessionId },
      });
      console.log(`Running GetPostLoginContent for ${sessionId}.`);
      const result = await callFetchData(api);
      if (result.status === 200) {
        const { resp } = result;
        setPostLoginContent(resp);
      }
    };
    getPostLoginContent();
  }, [sessionId]);

  useEffect(() => {
    if (postLoginContent) {
      const { contentType, url, content } = postLoginContent;
      if (contentType === 'URL') {
        const fragments = content.split(',');
        const label = fragments.find(fragment => fragment.startsWith('label')).split('##')[1];
        const labelHelp = fragments.find(fragment => fragment.startsWith('labelHelp')).split('##')[1];
        const url = fragments.find(fragment => fragment.startsWith('url')).split('##')[1];
        setTimeout(() => {
          setParsedContent({ label, labelHelp, url });
        }, 8000);
      } else if (contentType === 'NOT_SET') {
        setParsedContent({ label: '', labelHelp: '', url: '' });
      }
    }
  }, [postLoginContent]);

  return (
    <Paper
      elevation={0}
      id="test_guest_passThroughSuccess"
      sx={{
        borderRadius: 2,
        backgroundColor: '#000000',
        m: 2,
        mt: 10,
        boxShadow: 'rgb(0 0 0 / 25%) 2px 4px 10px 4px',
        opacity: 0.9,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          mx: 'auto',
          m: 4,
        }}
      >
        {customization?.logo?.data && <Logo data={customization.logo.data} css={customization.logo.css} />}
        {!customization?.logo?.data && (
          <Typography variant="h4" sx={{ textAlign: 'center', p: 1 }}>
            {tenantName || '-'}
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', paddingTop: 2 }}>
          {!parsedContent && (
            <Box sx={{ width: '100%', padding: 2 }}>
              <Typography variant="h6" sx={{ paddingBottom: 4 }}>
                Good things take a few seconds...
              </Typography>

              <LinearProgress />
            </Box>
          )}
          {parsedContent && (
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.primary', paddingBottom: 2 }}>
              {i18n.t('Messages.tncSuccessMessageAlt')}
            </Typography>
          )}
          {parsedContent && parsedContent.label.length > 0 && parsedContent.url.length > 0 && (
            <Stack direction="column" spacing={2} alignItems="center" sx={{ textAlign: 'center', paddingTop: 2 }}>
              <Typography variant="h6" sx={{ textAlign: 'center', color: 'primary.main', paddingBottom: 2 }}>
                {parsedContent.label}
              </Typography>
              <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                {parsedContent.labelHelp}
              </Typography>
              <Link
                id="post-login-content-link"
                sx={{
                  fontSize: 'h6.fontSize',
                  textAlign: 'center',
                  padding: 1,
                  backgroundColor: 'primary.main',
                  color: 'text.primary',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                    textDecoration: 'none',
                  },
                  borderRadius: 2,
                  width: '50%',
                }}
                href={parsedContent.url}
                // href="https://apps.apple.com/app/id6468645689"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Link>
            </Stack>
          )}
        </Box>
      </Box>
      {/* <Typography component="div" variant="caption" sx={{ padding: 2 }}>
        {navigator.userAgent}
      </Typography> */}
      <Footer />
    </Paper>
  );
};

PassThroughAccessSuccess.propTypes = {};

export default PassThroughAccessSuccess;
